import { PROFILE_UPDATE } from "@/graphql/mutations/profile";
import { PROFILE } from "@/graphql/queries/profile";
import { useMutation, useQuery } from "@apollo/client";
import { useAppGlobal } from "../app/AppGlobalProvider";
import { useEffect } from "react";
import { localStorageWrapper } from "@/utils/storage";
import { getNormalizedUserForSupport } from "@/utils/support";

export default function useOnlineHawzahChatWidget(activeChatWidget) {
    const [updateProfile] = useMutation(PROFILE_UPDATE);
    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const { isSupportUserSynced, setSupportUserIsSynced } = useAppGlobal();

    useEffect(() => {
        // Only run if this is the active chat widget
        if (activeChatWidget !== "OnlineHawzahChatWidget") {
            return;
        }

        function handler() {
            if (
                !localStorageWrapper.isImpersonated() &&
                profile?.userId &&
                "ChatWidget" in window
            ) {
                const profileSupportId = profile?.supportId;

                window.ChatWidget.getSupportId().then((supportId) => {
                    const sid =
                        profileSupportId && profileSupportId !== supportId
                            ? profileSupportId
                            : supportId;

                    window.ChatWidget.isGoftinoReady().then(() => {
                        window.ChatWidget.setSupportId(sid);
                    });

                    if (
                        !profileSupportId &&
                        !isSupportUserSynced &&
                        supportId
                    ) {
                        updateProfile({
                            variables: {
                                input: {
                                    id: parseInt(profile?.userId),
                                    supportId: supportId,
                                },
                            },
                            onCompleted: () => {
                                setSupportUserIsSynced();
                            },
                        });
                    }

                    window.ChatWidget.isGoftinoReady().then(() => {
                        const userData = getNormalizedUserForSupport(
                            "OnlineHawzahChatWidget",
                            profile
                        );
                        window.ChatWidget.setUserData(userData);
                    });
                });
            }
        }

        // Wait for ChatWidget to be available
        const checkChatWidget = () => {
            if (window.ChatWidget && window.ChatWidget.isInitialized()) {
                profile && handler();
            } else {
                // If ChatWidget is not available, wait a bit and try again
                setTimeout(checkChatWidget, 100);
            }
        };

        if (profile) {
            // Check if DOM is already loaded
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", checkChatWidget);
                return () => {
                    document.removeEventListener(
                        "DOMContentLoaded",
                        checkChatWidget
                    );
                };
            } else {
                // DOM is already loaded, check for ChatWidget
                checkChatWidget();
            }
        }
    }, [
        activeChatWidget,
        profile,
        isSupportUserSynced,
        updateProfile,
        setSupportUserIsSynced,
    ]);
}
